import styled from 'styled-components';

const Main = styled.main`
  padding-top: 24px;
`;

export { Main };
export default Main;
